var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('vue-picture-swipe',{attrs:{"options":{
      shareEl: false,
      index: 0,
      history: false,
      focus: false,
      showHideOpacity: true,
      clickToCloseNonZoomable: true,
      showAnimationDuration: 0,
      hideAnimationDuration: 0,
      tapToClose: true,
      spacing: 0,
      loop: false,
      preload: [1, 5],
    },"items":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }